export const BUY_STORY_PLAQUE_URL = 'https://seemylegacy.com/pages/qr-plaques';